export const Regex = {
	Phone: /^[\d]{3}-?[\d]{3}-?[\d]{4,}$/,
	ZipCode: /^\d{5}$/,
	Email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
};
